import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgItalicMedium = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 11,
	height: 18,
	viewBox: "0 0 11 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.47651 2.125C4.32026 2.125 4.20307 2.08594 4.12494 1.96875C4.04682 1.85156 4.00776 1.73438 4.04682 1.57812L4.20307 0.640625C4.20307 0.523438 4.28119 0.445312 4.35932 0.367188C4.43744 0.289062 4.55463 0.25 4.67182 0.25H10.5312C10.6874 0.25 10.8046 0.328125 10.8828 0.445312C10.9609 0.5625 10.9999 0.679688 10.9999 0.796875L10.8046 1.73438C10.7656 1.89062 10.7265 1.96875 10.6484 2.04688C10.5703 2.125 10.4531 2.125 10.3359 2.125H8.53901L5.88276 15.875H7.52338C7.64057 15.875 7.75776 15.9531 7.83588 16.0703C7.91401 16.1875 7.95307 16.3047 7.95307 16.4219L7.79682 17.3594C7.75776 17.5156 7.67963 17.5938 7.60151 17.6719C7.52338 17.75 7.40619 17.75 7.32807 17.75H1.46869C1.31244 17.75 1.15619 17.7109 1.07807 17.5938C0.999944 17.4766 0.960881 17.3594 0.999944 17.2031L1.19526 16.2656C1.19526 16.1484 1.27338 16.0703 1.35151 15.9922C1.42963 15.9141 1.50776 15.875 1.66401 15.875H3.42182L6.07807 2.125H4.47651Z",
		fill: "currentColor"
	})
});
export default SvgItalicMedium;
